<template>
  <span style="text-align:left;">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <v-input
        :value="value"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
      >
        <el-date-picker
          v-bind:value="preLoad(value)"
          v-on:input="event => $emit('input', preUpdate(event))"
          class="mt-3"
          :format="T('dd/MM/yyyy')"
          value-format="yyyy-MM-dd"
          style="width: 150px;"
          type="date"
          size="mini"
          :default-value="momentMaisUm(defaultValue)"
          @change="mudouMe()"
          placeholder
        ></el-date-picker>
      </v-input>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <span :class="{ 'text-xs-center': modo == 'list' }" v-if="value">{{
        value | moment(T("DD/MM/YYYY"))
      }}</span>
    </template>

    <template v-if="modo == 'filtro'">
      <el-date-picker
        v-model="desde"
        placeholder="Desde"
        :format="T('dd/MM/yyyy')"
        value-format="yyyy-MM-dd"
        style="width: 130px;"
        type="date"
        size="mini"
        @change="inputChanged"
        input-class="dataCampoInput"
      ></el-date-picker>
      <br />
      <el-date-picker
        v-model="ate"
        placeholder="Até"
        :format="T('dd/MM/yyyy')"
        value-format="yyyy-MM-dd"
        style="width: 130px;"
        type="date"
        size="mini"
        @change="inputChanged"
        input-class="dataCampoInput"
      ></el-date-picker>
    </template>
  </span>
</template>

<script>
import Datepicker from "vuejs-datepicker";

import { ptBR } from "vuejs-datepicker/dist/locale";

try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
export default {
  extends: _baseComponent,
  data() {
    return {
      ptBR,
      desde: null,
      ate: null
    };
  },
  computed: {
    defaultValue() {
      if (this.getComponentParam("de") != null) {
        return this.row[this.getComponentParam("de")];
      }
      return null;
    }
  },
  methods: {
    preLoad(myval) {
      return myval;
    },

    preUpdate(myval) {
      return myval;
    },

    mudouMe() {
      if (this.getComponentParam("de") != null) {
        let outro = this.row[this.getComponentParam("de")];

        if (this.value != null && outro != null) {
          if (this.value < outro) {
            this.row[this.getComponentParam("de")] = this.value;
          }
        }
      }
      if (this.getComponentParam("ate") != null) {
        let outro = this.row[this.getComponentParam("ate")];

        if (this.value != null && outro != null) {
          if (this.value > outro) {
            this.row[this.getComponentParam("ate")] = this.value;
          }
        }
      }
    },

    inputChanged() {
      let desde = this.desde;

      let ate = this.ate;

      if (this.modo == "filtro")
        setTimeout(
          () =>
            this.$emit(
              "input",
              this.desde || this.ate ? [this.desde, this.ate] : null
            ),
          100
        );
    }
  },
  components: {
    Datepicker
  },
  watch: {
    /*
    desde(val) {
      this.inputChanged();
    },
    ate(val) {
      this.inputChanged();
    },*/

    value: {
      deep: true,
      handler(old, newv) {
        // console.log("JMM");
        let val = this.value;
        this.desde = val != null ? val[0] : null;
        this.ate = val != null ? val[1] : null;
      }
    }
  }
};
</script>

<style>
.v-tabs__items {
  overflow: inherit !important;
}

.dataCampoInput {
  border: solid #ccc 1px;
  width: 100px;
}
</style>
